
<template>
  <div>
    <div class="fw-bold note-13 mb-2 mt-md-0 d-flex align-items-center justify-content-between" :class="{ 'mt-2': view === 'top' }">
      <div class="w-100 text-center">
        {{ view === 'bottom' ? trans('to_continue_purchase_choose_tariff') : trans('choose_tariff') }}:
        <span class="question-tooltip"
              data-toggle='tooltip'
              :title="trans('refundable_tooltip')">?</span>
      </div>
      <a class="rotation d-md-none d-block"
         v-if="view === 'bottom'"
         @click="$store.commit('toggleShowMobileDetailsBottom')"
         :class="{ rotated: !showMobileDetailsBottom }">
        <img alt="" src="/images/down3.svg"/>
      </a>
    </div>
    <RadioGroup :label="trans('non_refundable_ticket')"
                :active="refundable === 0"
                @click.native="$store.commit('setRefundable', 0)"/>
    <RadioGroup :label="`${trans('refundable_ticket')} (+${event.refundable_fee}%)`"
                :active="refundable === 1"
                @click.native="$store.commit('setRefundable', 1)"/>
  </div>
</template>

<script>
import RadioGroup from "./RadioGroup.vue"
import { mapState } from "vuex"

export default {
  name: "ChooseRefundable",
  components: {
    RadioGroup
  },
  props: {
    view: {
      type: String,
      default: 'top'
    }
  },
  computed: {
    ...mapState([
      'event',
      'refundable',
      'showMobileDetailsBottom'
    ]),
  }
}
</script>
